import { AbstractStore } from "~/extensions/utils/AbstractStore";
import { reactive } from "vue";
import { Pagination } from "~/extensions/api";
import Enumerable from "linq";
import { adminApi } from "~/api/admin/Api";
import { KeiyakushaFindConditionViewModel } from "~/pages/admin/Keiyakusha/Models/KeiyakushaFindConditionViewModel";
import { KeiyakushaFindConditionValidator } from "~/pages/admin/Keiyakusha/Models/KeiyakushaFindConditionValidator";
import { KeiyakushaListViewModel } from "~/pages/admin/Keiyakusha/Models/KeiyakushaListViewModel";
class Store extends AbstractStore {
    get keyName() {
        return "userCd";
    }
    init() {
        this.condition = new KeiyakushaFindConditionViewModel();
        this.storedCondition = new KeiyakushaFindConditionViewModel();
        this.conditionValid = new KeiyakushaFindConditionValidator(this.condition);
        this.defaultPagination = new Pagination(this.keyName, true);
        this.resetPagination();
    }
    async load() {
        let result = await adminApi.keiyakusha.find(this.condition, this.pagination);
        this.results = Enumerable.from(result.records).select(x => new KeiyakushaListViewModel(x)).toArray();
        this.pagination.rowsNumber = result.total;
        this.foundDate = result.executedDate;
    }
    clear() {
        super.clear();
    }
}
export let store = reactive(new Store());
